import React, { useEffect, useState } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import { app } from "../Firebase/firestore";
import "./support.css"; // import your css file

const NeedHelpWithUser = () => {
  const [helpData, setHelpData] = useState({});
  const [profiles, setProfiles] = useState({});

  useEffect(() => {
    const db = getDatabase(app);

    // Fetch needHelp data
    const helpRef = ref(db, "needHelp");
    onValue(helpRef, (snapshot) => {
      if (snapshot.exists()) {
        setHelpData(snapshot.val());
      }
    });

    // Fetch profileDashboard data
    const profileRef = ref(db, "profileDashboard");
    onValue(profileRef, (snapshot) => {
      if (snapshot.exists()) {
        setProfiles(snapshot.val());
      }
    });
  }, []);

  return (
    <div className="container">
      <h2>Need Help Requests</h2>

      {Object.entries(helpData).map(([userId, userHelps]) => {
        // profile for this userId
        const userProfile = profiles[userId] || {};

        return Object.entries(userHelps).map(([helpId, item]) => (
          <div key={helpId} className="help-card">
            <div className="help-header">
              <h3>{userProfile.username || "Unknown User"}</h3>
              <p>{userProfile.company_name || "No Company"}</p>
            </div>

            <p><strong>Name:</strong> {item.name}</p>
            <p><strong>Email:</strong> {item.email}</p>
            <p><strong>Phone:</strong> {item.phone}</p>
            <p><strong>Message:</strong> {item.message}</p>
          </div>
        ));
      })}
    </div>
  );
};

export default NeedHelpWithUser;
